<div class="category">
  <div class="edit">
    <ng-content></ng-content>
  </div>
  <span class="category-name">{{category.name}}</span>
  <img class="category-icon" [src]=category.icon alt="">
</div>

